import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HREF } from '@core';

@Component({
  selector: 'lib-bottom-footer',
  imports: [RouterLink],
  templateUrl: './bottom-footer.component.html',
  styleUrl: './bottom-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomFooterComponent {
  currentYear = new Date().getFullYear();
  readonly privacyPolicyPath = `/${HREF.INFO}/${HREF.PRIVACY_POLICY}`;
  readonly termsAndConditionsPath = `/${HREF.INFO}/${HREF.TERMS_AND_CONDITIONS}`;
}
